module.exports = __webpack_public_path__ + "static/media/r16.50d6ec1a.png";